// Thanks to Jonas Rosenqvist, stealing some logic and code.
export interface setUserAction {
  type: "SET_USER";
  user: System.User;
}

export interface setPublicationAction {
  type: "SET_PUBLICATIONS";
  publications: System.Publication[];
}

export interface setFilterQuery {
  type: "SET_FILTER_QUERY";
  filterQuery: System.FilterQuery;
}

export interface setFilters {
  type: "SET_FILTERS";
  filters: System.Tag[];
}

export interface setModalProps {
  type: "SET_MODAL_PROPS";
  modalProps: System.ModalProps;
}

export interface setProcessingCoookie {
  type: "SET_PROCESSING_COOKIE";
  processingCookie: boolean;
}

export interface IState {
  isLoading: boolean;
  user: System.User;
  publications: System.Publication[];
  filters: System.Tag[];
  filterQuery: System.FilterQuery;
  modalProps: System.ModalProps;
  processingCookie: boolean;
}

export const initialState: IState = {
  isLoading: true,
  processingCookie: true,
  user: {
    email: "",
    name: "",
    phone: "",
    username: "",
    groups: [],
    isAdmin: false,
  },
  publications: [],
  filters: [],
  filterQuery: {
    textSearch: "",
    tags: [],
    keywordsSelectorOperation: "or",
    sortBy: "name",
  },
  modalProps: {
    open: false,
    title: "",
    text: "",
    shouldRedirect: true,
    btn1Text: "",
    btn1Color: undefined,
    btn1OnClick: undefined,
    btn2OnClick: undefined,
    btn2Text: "",
    btn2Color: undefined,
    inputs: undefined,
  },
};
export type appAction =
  | setUserAction
  | setPublicationAction
  | setFilterQuery
  | setFilters
  | setModalProps
  | setProcessingCoookie;

export const reducer = (state: IState, action: appAction) => {
  switch (action.type) {
    case "SET_USER":
      return { ...state, user: action.user };
    case "SET_PUBLICATIONS":
      return { ...state, publications: action.publications };
    case "SET_FILTER_QUERY":
      return { ...state, filterQuery: action.filterQuery };
    case "SET_FILTERS":
      return { ...state, filters: action.filters };
    case "SET_MODAL_PROPS":
      return { ...state, modalProps: action.modalProps };
    case "SET_PROCESSING_COOKIE":
      return { ...state, processingCookie: action.processingCookie };
    default:
      return state;
  }
};
